export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/dllGroup.66fa55c1.svg","height":34,"width":127,"blurWidth":0,"blurHeight":0};